// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1___155bdf81ad6d5f4531a","cls2":"common-cls2___dc42d051eeb2e1e293b common-cls1___155bdf81ad6d5f4531a"};